import { render, staticRenderFns } from "./SingaporePodcast.vue?vue&type=template&id=8815a238&scoped=true&"
import script from "./SingaporePodcast.vue?vue&type=script&lang=js&"
export * from "./SingaporePodcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8815a238",
  null
  
)

export default component.exports